<template>
  <page :name="_t('Sblocco IP')">
    <pf-page-section>
      <pf-content>
        <p>{{ $t('I nostri sistemi di sicurezza sono in grado di bloccare in modo automatico molti tipi di attacchi diretti ai nostri server. In alcuni casi si può subire un blocco temporaneo degli accessi a causa di richieste che possono essere scambiate per uno di questi attacchi, come ad esempio quando si inserisce la password errata per troppe volte consecutive.') }}</p>

        <p>{{ $t('Se pensi di essere stato bloccato per errore puoi provare a richiedere lo sblocco del tuo IP da questo pannello. Il tuo IP verrà rilevato in modo automatico e precompilato ma puoi cambiarlo se stai accedendo da un altro sistema.') }}</p>

        <p>
          <i18n-t
            keypath="Se la richiesta non sortisce alcun effetto ti invitiamo ad {0} e i nostri tecnici prenderanno in carico la questione."
            tag="span"
          >
            <router-link :to="{ name: 'tickets' }">
              {{ $t('aprire un ticket') }}
            </router-link>
          </i18n-t>
        </p>
      </pf-content>
    </pf-page-section>

    <pf-page-section>
      <x-form
        :disabled="disabled"
        :submit-text="$t('Sblocca')"
        @submit="unban"
        style="max-width: 30ch"
      >
        <form-group :name="_t('Indirizzo IP')">
          <x-input
            id="unbanIP"
            v-model="ip"
            type="text"
            :placeholder="_t('Indirizzo IP')"
            required
          />
        </form-group>
      </x-form>
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { http } from '../http';
import { useAlertStore } from '@/store/alerts';
import { Resource } from '@/resources';
import { $t as _t } from '@/i18n';
import { useFunctionRunningState } from '@common/use';

const ip = ref('');

const { isRunning: disabled, run: unban } = useFunctionRunningState(async() => {
  const alertStore = useAlertStore();

  const ban = new Resource('ip-ban');
  const response = await ban.delete(ip.value);
  if (response) {
    alertStore.add({ title: _t('Le corrispondenze trovate sono state sbloccate'), type: 'success', toast: true });
  } else {
    alertStore.add({ title: _t("Non sono state trovate corrispondenze con l'indirizzo specificato"), type: 'warning', toast: true });
  }
}, { preventMultiple: true });

onMounted(async() => {
  ip.value = (await http.get('/ip')).data;
});
</script>
